/**
 * Cart table component
 *
 * @module cart-table
 * @version 1.0.0
 * @extends HTMLElement
 */

  customElements.component = 'cart-table';

  if (!customElements.get(customElements.component)) {

    class cartTable extends HTMLElement {

        /**
          * Cart Table web component
          *
          * @constructor
          */
        constructor() {

            super();

            this.initEvents();
        }

        /**
          * Init component events
          *
          * @returns {undefined}
          */
        initEvents() {

            this.initListenQuantity();
            //this.listenToDiscountBanner();
        }

        /**
         * Display error message
         *
         * @return {undefined}
         */
        displayErrorMessage(productId, quantity, error) {
            this.errorMessage = error;
            this.reloadCartData(productId, quantity);
        }

        /**
          * Listen when update the input quantuty
          */
        initListenQuantity() {

            this.querySelectorAll('[data-cart-table-item-id]').forEach(element => {
                element.addEventListener('change', event => {

                    let productId = event.target.dataset.cartTableItemId;
                    let quantity = event.target.value;
                    let ruleMax = event.target.dataset.ruleMax;

                    if (ruleMax != null && ruleMax != undefined && ruleMax != "") {

                        if (quantity <= ruleMax) {

                            if (productId) {
                                this.classList.add('loading-page');
                                window.theme.cart.update(productId, quantity).then((result) => {
                                    this.reloadCartData(productId, quantity);
                                }).catch((error) => {
                                    this.classList.remove('loading-page');
                                    this.displayErrorMessage(productId, quantity, error);
                                });
                            }
                        } else {
                            let message = 'This item has a maximum of ' + ruleMax + '.';
                            let error = {"message": message};

                            this.displayErrorMessage(productId, quantity, error);
                        }
                    } else {
                        if (productId) {
                            this.classList.add('loading-page');
                            window.theme.cart.update(productId, quantity).then((result) => {
                                this.reloadCartData(productId, quantity);
                            }).catch((error) => {
                                this.classList.remove('loading-page');
                                this.displayErrorMessage(productId, quantity, error);
                            });
                        }
                    }
                });
            });

        }

        listenToDiscountBanner() {
            const form = this.closest('form');
            form.addEventListener('DOMNodeInserted', event => {
                if (event.target.nodeType === 1 && event.target.classList.contains('bold_csp_qb_savings') && !this.bannerUpdated) {
                    this.bannerUpdated = true;
                    form.querySelector('.cart-summary__header').append(event.target);
                    event.target.style.display = 'block';
                    event.target.style.marginTop = '0.5rem';
                }
            });
        }

        /**
          * Reload cart data (Prices)
          *
          * @return {undefined}
          */
        reloadCartData(id, qty_added) {

            // Reaload cart page
            window.location.href = '/cart';

            /*fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' }).then(function(response) {
                return response.json();
            }).then(function(cart) {

                this.updateFreeShippingBar(cart.total_price);
                this.updateCartQuantity(cart.item_count);
                this.setPricesPage(cart, id);
                this.checkAvailabilityStock(cart, id, qty_added);

                if(qty_added <= 0) {
                    //remove product from cart
                    window.location.href = '/cart';
                }

            }.bind(this)).catch(function(error) {
                console.log(error);
            });*/
        }

        /**
          * Update prices on the page
          *
          * @return {undefined}
          */
        setPricesPage(cart, id) {
            cart.items.forEach(item => {

                if(id == item.id) {
                    var total_per_product = window.theme.money.format(item.final_line_price);

                    document.querySelectorAll("[data-product-final-price='" + item.id + "']").forEach(element => {

                        // Updating price(subtotal) on the table
                        element.innerText = total_per_product;
                    });
                }
            });

            // Updating subtotal
            var subtotalEl = document.querySelectorAll("[data-subtotal]");
            subtotalEl.forEach(item => {
              let priceText = window.theme.money.format(cart.total_price);
              if (window.Shopify !== undefined && window.Shopify.currency.active !== null) {
                  priceText += " " + window.Shopify.currency.active;
              }
              item.innerText = priceText;
          });

        }

        /**
          * Update the progress bar (Free Shipping App)
          *
          * @return {undefined}
          */
        updateFreeShippingBar(cart_total) {

            let event = new CustomEvent('change-shipping-bar-progress', {'detail': {
                cartTotal: cart_total
            }});

            window.dispatchEvent(event);
        }

        /**
          * Update Cart quantity
          *
          * @return {undefined}
          */
        updateCartQuantity(qty) {

            document.querySelectorAll('[data-cart-qty]').forEach( element => {
                element.innerHTML = qty;
            });

        }

        /**
          * Check if product has unavailability stock
          *
          * @return {undefined}
          */
        checkAvailabilityStock(cart, id, qty_added) {
            let message = document.querySelector('[data-cart-error-message]');
            let divMessage = message.querySelector('[data-message] span');

            if(!message) return null;

            cart.items.forEach(item => {

                if(id == item.id) {

                    if(qty_added > item.quantity) {

                        if(divMessage) {

                            let productTitle = item.title;

                            if(this.errorMessage.message){
                                divMessage.innerText = this.errorMessage.message;
                            }else{

                                // Default Message
                                divMessage.innerText = "Sorry, you can't add more " + productTitle + " to your basket. All available items (" + item.quantity + ") are already in your basket.";
                            }

                            // Show message
                            message.classList.remove("hidden");

                            let input = document.querySelectorAll('[data-cart-table-item-id=\"' + item.id + '\"]');

                            if(input) {
                                input.forEach(element => {
                                    element.value = item.quantity;
                                });
                            }

                            // Hide message after 7 seconds
                            setTimeout(() => {
                                message.classList.add("hidden");
                                divMessage.innerText = "";
                            }, 7000);

                        }
                    }
                }
            });
        }

    }

    customElements.define(customElements.component, cartTable);
}
